export const currencyFormat = (value) => {
  const currency_format = Intl.NumberFormat('en-IN');
  return currency_format.format(value);
};

export const wordFormat = (str) =>{
  return str.split('').join('')
}